import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const InfoIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 5,
  height = 13,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g data-testid="icon-info" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          d="M0 4.5h3.5v6h1v2H0v-2h1v-4H0z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <path
          d="M0.5 1.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
